export const BusinessOnboardingPopUpId = '[business-onboarding]';

export const GoogleTagManagerConfig = {
  gtmId: 'GTM-KJQWJS',
};

export const CacheControlHeaders = {
  MAX_AGE_1_MONTH: 'max-age=2592000',
};
